import axios from "axios";
import i18n from "../lang/index";

export const checkoutClient = axios.create({
  baseURL: process.env.GATSBY_API_URL,
});

checkoutClient.interceptors.request.use((config) => {
  const lang = i18n.resolvedLanguage ?? i18n.language ?? "pt-BR";

  config.headers = {
    ...config.headers,
    "Accept-Language": lang,
  };

  return config;
});
